import axios from './base'
import _axios from './interceptors'

export const loginController = axios.create({baseURL: '/sweb/login/'})
export const orderController = axios.create({baseURL: '/sweb/pOrder/'})
export const preDeliverController = axios.create({baseURL: '/sweb/booking'})
export const publicController = axios.create({baseURL: '/sweb/public/'})
export const ecpEContractController = axios.create({baseURL: '/sweb/ecpEContract'})
export const pfcBillInfoController = axios.create({baseURL: '/sweb/pfcBillInfo'})
export const pOrderAdjustController = axios.create({baseURL: '/sweb/pOrderAdjust'})
export const poscController = axios.create({baseURL: '/sweb/posc'})
export const srmSupPriceController = axios.create({baseURL: '/sweb/srmSupPrice'})
export const pfcCombinedInvoice = axios.create({baseURL: '/sweb/pfcCombinedInvoice'})
export const srmSupQualification = axios.create({baseURL: '/sweb/srmSupQualification'})
export const srmSupProductQualification = axios.create({baseURL: '/sweb/srmSupQualificationNew'})
export const pfinvoice = axios.create({baseURL: '/sweb/pfinvoice'})
export const supplierChargeReceipts = axios.create({baseURL: '/sweb/supplierChargeReceipts'})
export const supplierReturn = axios.create({baseURL: '/sweb/supplierReturn'})
export const supplierFine = axios.create({baseURL: '/sweb/supplierFine'})
export const helpCenter = axios.create({baseURL: '/sweb/helpCenter'})
export const feedback = axios.create({baseURL: '/sweb/feedback'})
export const pioneerFeedback = axios.create({baseURL: '/sweb/pioneerFeedback'})
export const dsmpSupDistribution = axios.create({baseURL: '/sweb/dsmpSupDistribution'})
export const srmSupInfo = axios.create({baseURL: '/sweb/srmSupInfo'})
export const rasUrl = axios.create({baseURL: '/sweb/rasUrl'})
export const supplierCargo = axios.create({baseURL: '/sweb/supplierCargo'})
// export const supplierVisitController = axios.create({baseURL: '/sweb/supplierVisit'})
// export const compensateController = axios.create({baseURL: '/sweb/subSidy'})
// 由于时间问题 先对后面项目统一加拦截器 放弃放入 vuex action做法
// export const supplierVisit = _axios.create({baseURL: '/sweb/supplierVisit'})
export const srmSupInfoApi = _axios.create({baseURL: '/sweb/srmSupInfo'})
export const bmsLogisticCloudApi = axios.create({baseURL: '/sweb/bmsLogisticCloud'})
export const certController = axios.create({baseURL: '/sweb/qualification'}) // 自主建品 商品资质部分
export const supplierContractController = _axios.create({baseURL: '/sweb//api/srm/com.sprucetec.pms.srm.service.SupplierContractService'}) // 查询供应商合同分类
export const paperInvoiceController = axios.create({baseURL: '/sweb/advanceInvoice'})
export const creatProdController = axios.create({baseURL: '/sweb/supProduct'})// 自主建品

export const materialController = axios.create({baseURL: '/sweb/material'})// 供应商物资

export const supSrvChargeController = axios.create({baseURL: '/sweb/supplierServiceCharge'})

export const supplierPoolController = axios.create({baseURL: '/sweb/supplierPool'}) // 供应商储备池
export const supplierMarketingfeeController = axios.create({baseURL: '/sweb/supplierMarketingfee'}) // 供应商营销费

export const supplierQualityController = axios.create({baseURL: '/sweb/quality'}) // 商品信息
export const supplierSupQualificationNewController = axios.create({baseURL: '/sweb/srmSupQualificationNew'}) // 供应商资质
export const supContractController = axios.create({baseURL: '/sweb/supContract'}) // 合同签署
export const supInvoiceController = axios.create({baseURL: '/sweb/pfinvoice'}) // 我的资质
export const supFrameController = axios.create({baseURL: '/sweb/supFrame'}) // 我的资质
export const ecpFrameContractController = axios.create({baseURL: '/sweb/ecpFrameContract'})
export const barcodeFeeController = axios.create({baseURL: '/sweb/barcodeFee'})
export const postPaidController = axios.create({baseURL: '/sweb/postpaid'}) // 后付费管理
export const placeOrderController = axios.create({baseURL: '/sweb/poOrder'}) // 自主下单
export const passportController = axios.create({baseURL: '/sweb/passport'}) // 供应商管理
export const supplierConfirmLetterController = axios.create({baseURL: '/sweb/supplierConfirmLetter'}) // 供应商询证函
export const qualificationTaskController = axios.create({baseURL: '/sweb/qualificationTask/'}) // 资质任务

loginController.interceptors.response.use(response => {
  return response
}, error => {
  if (!error.response && error.config.url === '/sweb/login/login') {
    return Promise.reject({code: '0000', msg: '目前网络有问题，请稍后再试'})
  }
  return Promise.resolve(error.response)
})



// WEBPACK FOOTER //
// ./src/api/controller.js